import { render, staticRenderFns } from "./change_status.vue?vue&type=template&id=7c38db15&scoped=true&"
import script from "./change_status.vue?vue&type=script&lang=js&"
export * from "./change_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c38db15",
  null
  
)

export default component.exports